import React from "react"
import { MenuList, MenuItem, Menu, MenuButton } from "@rockr/rock-ui"
import { CustomIcon } from "../CustomIcon"

type menuItem = {
  label: string
  icon?: string
  onClick?: (e: any) => any
}

type Props = {
  items: menuItem[]
}

export const VerticalMenu: React.FC<Props> = ({
  items
}) => {

  const renderMenuItems =(item: menuItem, index: number) => {
    return (  
      <MenuItem minH="40px" minWidth="auto" key={index} onClick={item.onClick}>
        { item.icon && (
          <CustomIcon name={item.icon} boxSize="20px" marginRight={3}/>
        )}
        <span>{ item.label }</span>
      </MenuItem>
    )
  }

  return (
    <Menu>
      <MenuButton type="button">
        <CustomIcon name='verticalMenu' boxSize="24px"/>
      </MenuButton>
      <MenuList  minWidth="auto">
        {items.map(renderMenuItems)}
      </MenuList>
    </Menu>
    )
}